import type { AnalyticDateFilter, DateTimeFilter } from '~/presentation/ui';
import type { IReportCampaign } from '~/modules/campaign-analytics/types';
import type { EOrderViewScope } from '~/modules/order-analytic/types';
import type { EAnalyticMode } from '~/modules/analytics/types';
import type { EReportSource } from '../types';

import { campaignToReportMetricMap, pageAnalyticToReportMetricMap } from '../constants';
import { EReportParamKeys } from '../types';

export interface IReportParams {
  locationPath?: string | null;
  reportCampaign?: IReportCampaign;
  mode?: EAnalyticMode;
  from?: EReportSource;
  customDateInfo?: Partial<AnalyticDateFilter>;
  viewScope?: EOrderViewScope;
}

export function getParamsByCampaign(params?: IReportParams) {
  return {
    ...(params?.reportCampaign?.id && {
      [EReportParamKeys.CAMPAIGN_ID]: params.reportCampaign.id,
    }),
    ...(params?.reportCampaign?.type && {
      [EReportParamKeys.CAMPAIGN_TYPE]: params.reportCampaign.type,
    }),
    ...(params?.reportCampaign?.groupId && {
      [EReportParamKeys.CAMPAIGN_GROUP_ID]: params.reportCampaign.groupId,
    }),
  };
}

export function getParamsByTime(currentDates: AnalyticDateFilter, dateTimePicked: DateTimeFilter) {
  return {
    ...(currentDates?.since && { [EReportParamKeys.SINCE]: currentDates.since?.toString() }),
    ...(currentDates?.until && { [EReportParamKeys.UNTIL]: currentDates.until?.toString() }),
    ...(currentDates?.alias && { [EReportParamKeys.ALIAS]: currentDates.alias }),
    ...(currentDates?.versionId && { [EReportParamKeys.VERSION_ID]: currentDates.versionId }),
    ...(currentDates?.title && { [EReportParamKeys.DATE_TITLE]: currentDates.title }),
    ...(dateTimePicked?.isCurrentVersion && {
      [EReportParamKeys.IS_CURRENT_VERSION]: `${dateTimePicked.isCurrentVersion}`,
    }),
  };
}

export const getReportMetricKey = (metricKey: string, campaignId?: string | null) => {
  return campaignId
    ? campaignToReportMetricMap[metricKey]
    : pageAnalyticToReportMetricMap[metricKey];
};
